// @flow
/* eslint-disable no-use-before-define */

// Types
import type { Trip } from '../models/trip'

// Constants
export const SORTER_ENUM = {
  RECOMMENDED: 'recommended',
  HIGH_PRICE: 'high_price',
  LOW_PRICE: 'low_price',
  FASTEST: 'fastest',
}

export const SORTER_FUNCTIONS = {
  [SORTER_ENUM.RECOMMENDED]: (trip1: Trip, trip2: Trip) => {
    if (trip1.tags.find((tag) => tag.type === 'recommended')) return -1
    if (trip2.tags.find((tag) => tag.type === 'recommended')) return 1
    return SORTER_FUNCTIONS[SORTER_ENUM.LOW_PRICE](trip1, trip2)
  },
  [SORTER_ENUM.LOW_PRICE]: (trip1: Trip, trip2: Trip) =>
    trip1.totalPrice - trip2.totalPrice,
  [SORTER_ENUM.HIGH_PRICE]: (trip1: Trip, trip2: Trip) =>
    trip2.totalPrice - trip1.totalPrice,
  [SORTER_ENUM.FASTEST]: (trip1: Trip, trip2: Trip) => {
    if (trip1.duration === trip2.duration) {
      return SORTER_FUNCTIONS[SORTER_ENUM.LOW_PRICE](trip1, trip2)
    }
    return trip1.duration - trip2.duration
  },
}
